import queryString from 'query-string';
import { SepaFilterI } from 'src/adminPanel/components/pages/offsetting/SepaFilter';
import { generateRequestHeadersPageable } from 'src/adminPanel/utils/helperClasses';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi, { CallApiResult } from '.';

export const getSepaPayments = (
    pageable: PageableQueryParams,
    filter: SepaFilterI = {
        directDebitVisible: 'true',
        hasOpenAmount: false,
        isDue: false,
    }
): Promise<CallApiResult> => {
    const requestHeaders = generateRequestHeadersPageable(pageable);
    let query = queryString.stringify({ ...filter }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    return callApi(`ordering/orders/sepa${query}`, { headers: requestHeaders });
};

export const getSepaPaymentDetails = (externalOrderId: string): Promise<CallApiResult> => {
    return callApi(`ordering/${externalOrderId}`);
};

export const addDirectDebitStatusProperty = (today: string, externalOrderId: string): Promise<CallApiResult> => {
    const value = `ausgeblendet ${today}`;
    return callApi(`ordering/${externalOrderId}/additionalProperty/directDebitState`, { method: 'PUT', data: value });
};

export const deleteDirectDebitStatusProperty = (externalOrderId: string): Promise<CallApiResult> => {
    return callApi(`ordering/${externalOrderId}/additionalProperty/directDebitState`, { method: 'DELETE' });
};

export const downloadSepaOrders = (externalOrderIds: string[]): Promise<CallApiResult> => {
    return callApi('api/orders/export', { method: 'PUT', responseType: 'blob', data: externalOrderIds });
};
